import { LoadingIndicator, SingleCombobox } from '@commenda/kakashi';
import type { IIndirectTaxSupportedRegion } from '@commenda/api/indirect-tax/registrations/types';

interface IndirectTaxRegionSelectorProps {
  regions: IIndirectTaxSupportedRegion[];
  isLoading: boolean;
  selectedRegionId: string;
  onRegionChange: (regionId: string) => void;
  isLocked?: boolean;
}

export function IndirectTaxRegionSelector({
  regions,
  isLoading,
  selectedRegionId,
  onRegionChange,
  isLocked = false,
}: IndirectTaxRegionSelectorProps) {
  const regionOptions = regions.map((r) => ({
    value: r.regionId,
    label: r.regionName,
  }));

  const selectedRegionName =
    regions.find((r) => r.regionId === selectedRegionId)?.regionName ?? '';

  return (
    <div className="flex flex-col gap-xs">
      <p className="txt-small-medium text-text-secondary">
        Select region
        <span className="text-utility-violet-600 ml-0.5">*</span>
      </p>
      {isLoading ? (
        <div className="flex items-center gap-sm h-11">
          <LoadingIndicator size={16} />
          <span className="txt-small-regular text-text-tertiary">
            Loading regions...
          </span>
        </div>
      ) : isLocked ? (
        <div className="flex items-center h-11 px-3 rounded-md bg-bg-secondary border border-border-primary txt-medium-regular text-text-secondary">
          {selectedRegionName || '—'}
        </div>
      ) : (
        <SingleCombobox
          value={selectedRegionId}
          setValue={onRegionChange}
          options={regionOptions}
          placeholder="Select region"
          _className="txt-medium-regular text-text-secondary h-11 px-3"
          canClearSelection={false}
          hideSearch
        />
      )}
    </div>
  );
}
